import { render } from "./QuickSearchBusinessSignalNewsCard.vue?vue&type=template&id=24eed234&scoped=true"
import script from "./QuickSearchBusinessSignalNewsCard.vue?vue&type=script&lang=js"
export * from "./QuickSearchBusinessSignalNewsCard.vue?vue&type=script&lang=js"

import "./QuickSearchBusinessSignalNewsCard.vue?vue&type=style&index=0&id=24eed234&lang=scss&scoped=true"
/* custom blocks */
import block0 from "@/locales/common.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2Fquick_search%2Fcards%2Fnews%2FQuickSearchBusinessSignalNewsCard.vue&external"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/components/elements/quick_search/news/quick-search-business-signal-news-card.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fusr%2Fapp%2Fsrc%2Fcomponents%2Felements%2Fquick_search%2Fcards%2Fnews%2FQuickSearchBusinessSignalNewsCard.vue&external"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eed234"]])

export default __exports__